import { createMaperDarkTheme, type CustomTokens } from '../MaperTheme';

// Dark counterpart of `lightTheme.ts`: foreground/stroke roles take the mid-saturation step,
// which stays legible on a dark surface, and the tints keep the dark surfaces. Dark mode is
// not reachable from the UI today (`setTheme` has no caller), so these await a design review.
const customTokensDark: CustomTokens = {
    // Health status - Primary variants (text/icon tone)
    colorHealthOptimal1Bg: '#4FB77C',
    colorHealthOptimal1Fg: '#1A3A2A',
    colorHealthOptimal1Stroke: '#4FB77C',

    colorHealthAcceptable1Bg: '#C9B84A',
    colorHealthAcceptable1Fg: '#2A3A1A',
    colorHealthAcceptable1Stroke: '#C9B84A',

    colorHealthAttention1Bg: '#F18A3A',
    colorHealthAttention1Fg: '#3A2A1A',
    colorHealthAttention1Stroke: '#F18A3A',

    colorHealthDanger1Bg: '#DC2626',
    colorHealthDanger1Fg: '#3A1A1A',
    colorHealthDanger1Stroke: '#DC2626',

    colorHealthUnknown1Bg: '#ADB5BD',
    colorHealthUnknown1Fg: '#2A2A2A',
    colorHealthUnknown1Stroke: '#ADB5BD',

    // Health status - Secondary variants (dark surface tints). `*2Fg` is the label tone
    // on the tint; on a dark surface the vivid step is the legible one.
    colorHealthOptimal2Bg: '#1A3A2A',
    colorHealthOptimal2Fg: '#4FB77C',
    colorHealthOptimal2Stroke: '#4FB77C',

    colorHealthAcceptable2Bg: '#2A3A1A',
    colorHealthAcceptable2Fg: '#C9B84A',
    colorHealthAcceptable2Stroke: '#C9B84A',

    colorHealthAttention2Bg: '#3A2A1A',
    colorHealthAttention2Fg: '#F18A3A',
    colorHealthAttention2Stroke: '#F18A3A',

    colorHealthDanger2Bg: '#3A1A1A',
    colorHealthDanger2Fg: '#DC2626',
    colorHealthDanger2Stroke: '#DC2626',

    colorHealthUnknown2Bg: '#2A2A2A',
    colorHealthUnknown2Fg: '#ADB5BD',
    colorHealthUnknown2Stroke: '#ADB5BD',

    // Informative / in-progress blue (dark). Same treatment as the health families:
    // the vivid step lightens so it stays legible on a dark surface.
    colorInfo1Bg: '#5CA0E0',
    colorInfo1Stroke: '#5CA0E0',
    colorInfo2Bg: '#152A3D',
    colorInfo2Fg: '#5CA0E0',

    // Event accents (dark) — Win borrows the Optimal trio, Alarm the Danger one.
    colorEventWinFg: '#4FB77C',
    colorEventWinBg: '#1A3A2A',
    colorEventWinStroke: '#4FB77C',

    colorEventAlarmFg: '#DC2626',
    colorEventAlarmBg: '#3A1A1A',
    colorEventAlarmStroke: '#DC2626',
};

export const darkTheme = createMaperDarkTheme(customTokensDark);
